import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import style from "./Main.module.scss";
import Button from "../../../Button/button";
import Input from "../../../input/signInput/input"
import Toast from ".././../../Toast/Toast"
import toEnglishNumber from "../../../../helpers/actions/toEnglishNumber";
import { forgetPassword } from "../../../../actions/APIcalls";
import auth from "../../../../auth";
import Cookies from "js-cookie";

const Main = (props) => {

    const [tel, setTel] = useState('')
    const [password, setPassword] = useState('')
    const [telError, setTelError] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [showToast, setShowToast] = useState({ show: false, text: "" })
    const [rememberPassword, setRememberPassword] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleBlur = (tag, e) => {
        if (tag === "tel") {
            telValidation();
        } else {
            passwordValidation()
        }
    }

    // useEffect(() => {
    //     if (Cookies.get('token')) {
    //         handleRedirectHome()
    //     }
    // }, []);

    const handleRedirectHome = () => {
        props.history.push('/')
    }

    const telValidation = () => {
        let reg = new RegExp("^(09)[0-9]{9}$");
        if (reg.test(toEnglishNumber(tel)) && tel.length !== 0) {
            setTelError('')

            return true
        } else {
            if (tel.length === 0) {
                setTelError('شماره موبایل خود را وارد کنید')

            } else {
                setTelError('شماره وارد شده صحیح نیست!')
            }
            return false;
        }
    }
    const passwordValidation = () => {
        if (!password) {
            setPasswordError('رمز عبور خود را وارد کنید')

        } else {
            setPasswordError('')
        }
    }

    const handleForm = (tag, e) => {
        if (tag === 'tel') {
            let temp1 = tel;
            let reg = new RegExp(/^\d+$/);
            // console.log(reg.test(temp1), e.target.value, "54545");
            if (reg.test(toEnglishNumber(e.target.value)) && e.target.value.length < 12) {
                temp1 = toEnglishNumber(e.target.value);
            } else if (e.target.value === "") {
                // console.log("empty");
                temp1 = ""
            }
            setTel(temp1);
        }
        if (tag === 'password') {
            setPassword(e.target.value)
        }
    }


    const redirectToNewPassword = async () => {
        if (tel !== '' && tel.length > 10 && tel.length < 14) {
            const res = await forgetPassword({ phone: tel });
            if (typeof res !== "undefined" && typeof res.data !== "undefined" && res.data.success) {
                props.history.push(
                    {
                        pathname: '/signin/code',
                        state: { tel: toEnglishNumber(tel) }
                    }
                )
            } else {
                //todo show error
            }
        } else {
            props.history.push('/signin/phone')
        }
    }

    const closeToast = () => {
        setShowToast({ show: false, text: '' })
    }


    const registerForm = async () => {
        if (tel && password) {
            if (!passwordError && !telError) {
                setLoading(true)
                let params = {
                    phone: toEnglishNumber(tel),
                    password: toEnglishNumber(password),
                    rememberMe: rememberPassword,
                }
                auth.login(params, setShowToast, setLoading)
            }
        } else {
            if (!tel) {
                setTelError('شماره موبایل خود را وارد کنید')
            }
            if (!password) {
                setPasswordError('رمز عبور خود را وارد کنید')
            }
        }
    }

    return (
        <div className={style.signUpStepOne}>
            <Toast
                tag='repeatedNumber'
                value={showToast.show}
                text={showToast.text}
                parentClose={closeToast}
                hasButton={true}
                buttonText='بازیابی رمز عبور'
                buttonAction={() => redirectToNewPassword()}
            />

            <div className={style.stepOneFrame}>
                <h3>ورود</h3>
                <div className={style.stepOneFormFrame}>
                    <Input
                        type="text"
                        disabled={false}
                        label="شماره موبایل"
                        placeholder=" - - - - - - - - - ۰۹"
                        tag="tel"
                        value={tel}
                        error={telError}
                        tooltip=''
                        onchange={handleForm}
                        onblur={handleBlur}
                    />
                    <div className={style.space}></div>
                    <div onKeyDown={(event) =>
                        event.key === "Enter" ? registerForm() : null
                    }>
                        <Input
                            type="password"
                            disabled={false}
                            label="رمز عبور"
                            placeholder="رمز عبور"
                            tag="password"
                            value={password}
                            error={passwordError}
                            tooltip=''
                            onchange={handleForm}
                            onblur={handleBlur}
                        />
                    </div>
                    <div className={style.space}></div>
                    <div
                        onKeyDown={(event) =>
                            event.key === "Enter" ? registerForm() : null
                        }
                        onClick={() => setRememberPassword(!rememberPassword)}
                        className={style.forgotPasswordWrapper}
                    >
                        <input className={rememberPassword ? style.inputChecked : style.inputCheckboxClass}
                            type='checkbox'></input>
                        <p>به‌خاطر سپردن اطلاعات ورود</p>
                    </div>
                    <div
                        onClick={redirectToNewPassword}
                        className={style.recoverPassword}>
                        <p>بازیابی رمز عبور</p>
                    </div>

                </div>
                <div className={style.buttonFrame}>
                    <Button
                        loading={loading}
                        disabled={false}
                        tag="register"
                        type="solid"
                        label="ورود"
                        onclick={registerForm}
                    />
                    <p className={style.registerLink}>حساب‌کاربری ندارید؟
                        <span className={style.link}>
                            <Link
                                to='/signup/stepone'>ثبت‌نام در موبیشا</Link>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default withRouter(Main);